import {
  PayPalScriptProvider,
  ReactPayPalScriptOptions,
} from '@paypal/react-paypal-js';
import { PayPalButton } from './paypal-button';

const OPTIONS: ReactPayPalScriptOptions = {
  clientId: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID!,
  // TODO: get currency from the cart in future
  currency: 'USD',
  intent: 'capture',
  enableFunding: '',
  // eslint-disable-next-line @cspell/spellchecker
  disableFunding: ['sepa', 'card', 'paylater', 'venmo'],
};

export const PayPalForm = () => (
  <PayPalScriptProvider options={OPTIONS}>
    <PayPalButton />
  </PayPalScriptProvider>
);
